import sanitize from 'sanitize-filename';

export const sanitizeFileName = (input = '') => {
  return sanitize(input)
    .toLowerCase()
    .trim()
    .replace(/[^a-zA-Z0-9()_.]/gi, '-');
};
